import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Root error boundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] p-6">
          <div className="max-w-md text-center space-y-4">
            <h1 className="text-xl font-semibold">Qualcosa è andato storto</h1>
            <pre className="text-xs text-left bg-white border border-[#EAE7E1] rounded-lg p-3 overflow-auto max-h-40">
              {String(this.state.error)}
            </pre>
            <button
              onClick={() => {
                this.setState({ error: null });
                window.location.href = "/";
              }}
              className="h-10 px-4 rounded-md bg-[#2E4A3B] text-white text-sm font-medium"
            >
              Torna alla home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
